import { render, staticRenderFns } from "./SportsScores.vue?vue&type=template&id=1b68df20&scoped=true"
import script from "./SportsScores.vue?vue&type=script&lang=js"
export * from "./SportsScores.vue?vue&type=script&lang=js"
import style0 from "./SportsScores.vue?vue&type=style&index=0&id=1b68df20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b68df20",
  null
  
)

export default component.exports